(() => {
  angular.module('pims').directive('format', ["$filter", $filter => {
    'ngInject';

    return {
      require: '?ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;
        ctrl.$formatters.unshift(function (a) {
          return $filter(attrs.format)(ctrl.$modelValue, '£');
        });
        elem.bind('blur', function (event) {
          var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, '');
          elem.val($filter(attrs.format)(plainNumber, '£'));
        });
      }
    };
  }]);
})();